var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChallenge1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 83,
    viewBox: "0 0 88 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 80.9565H86.5M10.2772 80.9565V46.7718H24.5978V80.9565V7.96741H73.5652V80.9565",
    stroke: "#111111",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1576 19.0543H38.9185C38.6634 19.0543 38.4565 19.2611 38.4565 19.5163V28.7554C38.4565 29.0105 38.6634 29.2174 38.9185 29.2174H48.1576C48.4128 29.2174 48.6196 29.0105 48.6196 28.7554V19.5163C48.6196 19.2611 48.4128 19.0543 48.1576 19.0543Z",
    stroke: "#FF6000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1737 19.0543H56.9346C56.6795 19.0543 56.4727 19.2611 56.4727 19.5163V28.7554C56.4727 29.0105 56.6795 29.2174 56.9346 29.2174H66.1737C66.4289 29.2174 66.6357 29.0105 66.6357 28.7554V19.5163C66.6357 19.2611 66.4289 19.0543 66.1737 19.0543Z",
    stroke: "#FF6000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1576 36.1467H38.9185C38.6634 36.1467 38.4565 36.3536 38.4565 36.6087V45.8478C38.4565 46.1029 38.6634 46.3098 38.9185 46.3098H48.1576C48.4128 46.3098 48.6196 46.1029 48.6196 45.8478V36.6087C48.6196 36.3536 48.4128 36.1467 48.1576 36.1467Z",
    stroke: "#FF6000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1737 36.1467H56.9346C56.6795 36.1467 56.4727 36.3536 56.4727 36.6087V45.8478C56.4727 46.1029 56.6795 46.3098 56.9346 46.3098H66.1737C66.4289 46.3098 66.6357 46.1029 66.6357 45.8478V36.6087C66.6357 36.3536 66.4289 36.1467 66.1737 36.1467Z",
    stroke: "#FF6000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1576 53.2391H38.9185C38.6634 53.2391 38.4565 53.446 38.4565 53.7011V62.9402C38.4565 63.1954 38.6634 63.4022 38.9185 63.4022H48.1576C48.4128 63.4022 48.6196 63.1954 48.6196 62.9402V53.7011C48.6196 53.446 48.4128 53.2391 48.1576 53.2391Z",
    stroke: "#FF6000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1737 53.2391H56.9346C56.6795 53.2391 56.4727 53.446 56.4727 53.7011V62.9402C56.4727 63.1954 56.6795 63.4022 56.9346 63.4022H66.1737C66.4289 63.4022 66.6357 63.1954 66.6357 62.9402V53.7011C66.6357 53.446 66.4289 53.2391 66.1737 53.2391Z",
    stroke: "#FF6000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2065 64.9022V79.4569H48.7339V64.9022H58.2065Z",
    fill: "#FF3B0A",
    stroke: "#FF6000",
    strokeWidth: 3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1577 7.50543V1.5H53.7012",
    stroke: "#FF6000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChallenge1);
export default __webpack_public_path__ + "static/media/challenge1.c1439b2fe215c5d98f2890fe3d74b572.svg";
export { ForwardRef as ReactComponent };